/**
 * Authentication layout component
 * Handles switching between login and register forms
 */

import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../core/contexts/AuthContext';
import Login from './Login';
import Register from './Register';

/**
 * Authentication layout component
 * 
 * @returns {JSX.Element} Authentication layout component
 */
const AuthLayout = () => {
  const [showLogin, setShowLogin] = useState(true);
  const { isAuthenticated, loading } = useAuth();
  
  // If user is authenticated, redirect to home page
  if (isAuthenticated && !loading) {
    return <Navigate to="/home" replace />;
  }
  
  return (
    <div className="min-h-screen bg-gray-50">
      {showLogin ? (
        <Login switchToRegister={() => setShowLogin(false)} />
      ) : (
        <Register switchToLogin={() => setShowLogin(true)} />
      )}
    </div>
  );
};

export default AuthLayout;